var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-image',_vm._b({},'el-image',_vm.$attrs,false),[_c('template',{slot:"placeholder"},[_vm._t("placeholder")],2),_c('template',{slot:"error"},[_vm._t("error")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }